import "./App.css";
import Burger from "./Components/Main page/Carousal/Burger";
import Rolls from "./Components/Main page/Carousal/Rolls";
import Pizza from "./Components/Main page/Carousal/Pizza";
import Fryers from "./Components/Main page/Carousal/Fryers";
import Drinks from "./Components/Main page/Carousal/Drinks";
import Deals from "./Components/Main page/Carousal/Deals";
import Home from "./Components/Home";
import Delivery from "./Components/Delivery";
import PastaAndSandwiches from "./Components/Main page/Carousal/Sandwiches";
import { saveAs } from "file-saver";

function App() {
  const img = "./Images/Menu.jpeg";
  const downloadimg = () => {
    saveAs(img, "Menu.jpeg");
  };
  return (
    <>
      {/* <Carousal/> */}
      <div className="fixed z-40 flex justify-center p-2 my-5 right-3 bottom-3">
        <button
          className='"bg-white flex  items-center text-yellow-400 text-lg px-3 py-2 font-fancy rounded-full bg-white hover:text-yellow-700 border-2 border-yellow-500 cursor-pointer transition-all duration-75 group'
          onClick={downloadimg}
        >
          Download Menu
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-16 h-6 text-yellow-400 group-hover:text-yellow-700"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"
            />
          </svg>
        </button>
      </div>
      <div className="fixed z-40 flex flex-col items-center p-2 mt-3 right-5 bottom-36">
        <a href="tel:056 3772222" target="_blank" rel="noreferrer noopener">
          <button className="flex items-center px-3 py-2 transition-all duration-75 bg-white border-2 border-green-600 rounded-full shadow-xl cursor-pointer animate-button text-green-600/70 text-md font-fancy hover:drop-shadow-xl hover:text-green-600 shadow-gray-400 group">
            Give us a Call
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-10 h-5 group-hover:text-green-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
              />
            </svg>
          </button>
        </a>
      </div>
      <div className="fixed z-40 flex justify-center p-2 my-5 right-5 bottom-16">
        <a
          href="https://wa.me/+923053333850"
          target="_blank"
          rel="noreferrer noopener"
        >
          <button className='"bg-white text-green-400 text-md px-4 py-2 font-fancy rounded-full  cursor-pointer  transition-all duration-75 bg-white border-2 border-green-500'>
            Message on WhatsApp
          </button>
        </a>
      </div>
      <Home />
      <Burger />
      <Pizza />
      <Rolls />
      <Fryers />
      <PastaAndSandwiches />
      <Drinks />
      <Deals />
      <Delivery />
    </>
  );
}

export default App;
